module.exports = __webpack_public_path__ + "static/media/tv.81a39178.svg";